import { render, staticRenderFns } from "./_keyword.vue?vue&type=template&id=0ed35df8"
import script from "./_keyword.vue?vue&type=script&setup=true&lang=ts"
export * from "./_keyword.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports